import React, {PropTypes} from "react";
import {connect} from "react-redux";
import ExitTable from "./ExitTable";
import ModalFull from "./ModalFullFinal";
import ModalViewExitImage from "./ModalViewExitImage";
import axios from "axios";
import Modal from "./Modal";
import ModalDelete from "./ModalDelete";
import ModalDeleteView from "./ModalDeleteView";
import moment from "moment";
import Checkbox from "material-ui/Checkbox";
import csvConvert from "../../../classes/csvConvert";
import Button from "react-bootstrap/lib/Button";
import LoadingSpinner from "../../loadingSpinner";


function checkPending(exit) {
  let flag = false;

  if (exit.empStatus == 'R' || exit.empStatus == 'P')
    return true;
  let keys = ['itStatus', 'managerStatus', 'adminStatus', 'financeStatus'];

  if (exit.empStatus == 'I') {
    keys.map((node)=> {
      if (exit[node] == 'pending')
        flag = true;
    })
  }
  return flag;

}


function convertDate(employees) {
  let emp = new Array();
  employees.map((node)=> {
    if (node.doLeaving != null) {
      node.doL = new Date(node.doLeaving);

    }
    else
      node.doL = 'NA';
    if (node.doResignation != null) {
      node.doR = new Date(node.doResignation);
    }
    else node.doR = 'NA';

    if (node.dateOfJoining != null) {
      node.dateOfJoining = new Date(node.dateOfJoining);
    }
    else node.dateOfJoining = null;

    if (checkPending(node) && node.empStatus != 'F')
      emp.push(node);

    if(node.imageUrl != null){
      const img = node.imageUrl;
      const img1 = img.replace("http",'https');
      const img2 = img1.substring(0,12) + "8" + img1.substring(12 + 1)
      node.imageUrl = img2;
    }
    else
      node.imageUrl = null;
  });
  return emp;

}

function getTodaysExits(employees) {
  let todayDate = new Date();
  let emp = new Array();
  employees.map((node)=> {
    if (node.doLeaving != null) {
      node.doL = moment(node.doLeaving).format('YYYY-MM-DD');

    }
    else
      node.doL = 'NA';
    if (node.doResignation != null) {
      node.doR = moment(node.doResignation).format('YYYY-MM-DD');
      ;

    }
    else node.doR = 'NA';

    if (node.dateOfJoining != null) {
      node.dateOfJoining = moment(node.dateOfJoining).format('YYYY-MM-DD');
    }
    else node.dateOfJoining = null;

    if (checkPending(node) && (node.empStatus != 'F' && node.empStatus != 'I') && ((new Date(node.doLeaving).getDate() == todayDate.getDate() && new Date(node.doLeaving).getDay() == todayDate.getDay()) || (new Date(node.doLeaving) < new Date())))
      emp.push(node)
  });
  return emp;
}

function getPendingExits(employees) {
  let todayDate = new Date();
  let emp = new Array();
  employees.map((node)=> {
    if (node.doLeaving != null) {
      node.doL = moment(node.doLeaving).format('YYYY-MM-DD');

    }
    else
      node.doL = 'NA';
    if (node.doResignation != null) {
      node.doR = moment(node.doResignation).format('YYYY-MM-DD');
      ;

    }
    else node.doR = 'NA';

    if (node.dateOfJoining != null) {
      node.dateOfJoining = moment(node.dateOfJoining).format('YYYY-MM-DD');
      ;
    }
    else node.dateOfJoining = null;

    if (checkPending(node) && node.empStatus == 'I')
      emp.push(node)
  });
  return emp;

}
class ExitHome extends React.Component {

  constructor() {
    super();
    this.state = {
      employees: [],
      employee: null,
      open: false,
      openDelete: false,
      disable: false,
      fnf: false,
      today: false,
      pending: false,
      viewExitImage: false,
      loading:true
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.edit = this.edit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.openExit = this.openExit.bind(this);
    this.closeExit = this.closeExit.bind(this);
    this.trueDisable = this.trueDisable.bind(this);
    this.falseDisable = this.falseDisable.bind(this);
    this.openfnf = this.openfnf.bind(this);
    this.closefnf = this.closefnf.bind(this);
    this.todaysExits = this.todaysExits.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.downloadCsvPersonal = this.downloadCsvPersonal.bind(this);
    this.viewImage = this.viewImage.bind(this);
    this.closeViewImage = this.closeViewImage.bind(this);
  }

  downloadCsvPersonal(dump) {
      let csvContent = new csvConvert();

      let tableData = csvContent.convertArrayOfAnyObjectsToCSV({data: dump});
      console.log(tableData);

      let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
      if ( window.webkitURL ) {
                blob = window.webkitURL.createObjectURL(blob);
      } else if ( window.URL && window.URL.createObjectURL ) {
                blob = window.URL.createObjectURL(blob);
      } else {
            console.log("error in personal details csv download: blob");
      }
      let getCsv = new Promise((resolve, reject)=> {
         this.setState({csv: blob});
         resolve(true);
      });

      getCsv.then((response)=> {
        this.download.click();
      })
  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let tableData = csvContent.convertArrayOfExitObjectsToCSV({data: this.state.allEmployees});

    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.webkitURL.createObjectURL(blob);
    console.log(blob);
    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob})
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  openfnf() {
    this.setState({fnf: true});

  }

  closefnf() {
    this.setState({fnf: false});
  }

  trueDisable() {
    this.setState({disable: true})
  }

  falseDisable() {
    this.setState({disable: false})
  }

  openExit() {
    this.setState({openDelete: true})
  }

  closeExit() {
    this.setState({openDelete: false})
  }

  open() {
    this.setState({open: true})
  }

  close() {
    this.setState({open: false})
  }

  edit(employee) {
    this.setState({employee: employee});
  }

  viewImage(emp) {
    this.setState({employee: emp, viewExitImage: true})
  }

  closeViewImage() {
    this.setState({viewExitImage: false});
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/getExits", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;
      employees = convertDate(employees);

      this.setState({employees: employees, loading: false})
    }).catch((err)=> {

    });
  }

  todaysExits() {
    this.setState({allEmployees: this.state.employees});
  }


  componentDidMount() {
    this.props.changeBanner("Exits");
    console.log("Component mounted");
    axios.get(process.env.REQ_URL + "/getExits", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;
      console.log(260,employees);
      employees = convertDate(employees);
      this.setState({employees: employees, allEmployees: employees, loading: false})
    }).catch((err)=> {

    });
  }


  render() {
    return (
      <div>
        {this.state.viewExitImage ? <ModalViewExitImage
          employee={this.state.employee}
          open={this.state.viewExitImage}
          viewImage={this.viewImage}
          closeViewImage={this.closeViewImage}
        /> : null}

        {this.state.fnf ? <ModalFull
          employee={this.state.employee}
          open={this.state.fnf}
          edit={this.edit}
          close={this.closefnf}

          empRefresh={this.props.refresh}
          refresh={this.refresh}
        /> : null}

        {this.state.open ? <Modal employee={this.state.employee}
                                  open={this.state.open}
                                  edit={this.edit}
                                  close={this.close}
                                  url="/applyExit"
                                  empRefresh={this.props.refresh}
                                  refresh={this.refresh}/> : null}
        {this.state.openDelete ? <ModalDelete employee={this.state.employee}
                                              empRefresh={this.props.refresh}
                                              remove={this.props.remove}
                                              disabled={this.state.disable}
                                              display="inline"
                                              open={this.state.openDelete}
                                              edit={this.edit}
                                              close={this.closeExit}
                                              refresh={this.refresh}

        /> : null}
        {this.state.disable ? <ModalDeleteView employee={this.state.employee}
                                               empRefresh={this.props.refresh}
                                               remove={this.props.remove}
                                               disabled={this.state.disable}
                                               display="inline"
                                               open={this.state.disable}
                                               edit={this.edit}
                                               close={this.falseDisable}
                                               refresh={this.refresh}

        /> : null}
        <div className="col-md-12">
          <div className="col-md-4">
            <Button
              onClick={this.downloadCsv}
              style={{backgroundColor: 'rgb(92, 184, 92)'}}
            ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>
            <a href={this.state.csv} download={"Employee_Personal_Details"} ref={(input) => {this.download = input;}}/>
                        <button
                          style={{marginLeft: '10px'}}
                          className="btn btn-default"
                          onClick={()=> {
                            axios.get(process.env.REQ_URL + "/aboutEmpPersonalDetails?q=exit", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                              this.downloadCsvPersonal(response.data.data);
                            }).catch((error)=> {
                            });
                          }}
                        >Download Personal Details
                        </button>
          </div>
          <div className="col-md-2" style={{display: 'inline', paddingLeft: 0}}>
            <Checkbox label="Today's Exits"
                      checked={this.state.today}
                      onCheck={()=> {
                        if (!this.state.today) {
                          let employees = this.state.allEmployees;
                          let new_employees = getTodaysExits(employees);
                          this.setState({employees: new_employees, today: !this.state.today, pending: false});

                        }
                        else
                          this.setState({employees: this.state.allEmployees, today: !this.state.today});
                      }}/>
          </div>
          <div className="col-md-2" style={{display: 'inline'}}>
            <Checkbox label="Pending Exits"
                      checked={this.state.pending}
                      onCheck={()=> {
                        if (!this.state.pending) {
                          let employees = this.state.allEmployees;
                          let new_employees = getPendingExits(employees);
                          this.setState({employees: new_employees, pending: !this.state.pending, today: false});
                        }
                        else
                          this.setState({employees: this.state.allEmployees, pending: !this.state.pending});
                      }}/>
          </div>

        </div>
        <a href={this.state.csv} download={"Exit" + moment(new Date()).format('YYYY-MM-DD') + ".csv"} ref={(input) => {
          this.download = input;
        }}/>
          {this.state.loading ? <LoadingSpinner/> : <ExitTable
          trueDisable={this.trueDisable}
          falseDisable={this.falseDisable}
          edit={this.edit}
          open={this.open}
          openfnf={this.openfnf}
          openExit={this.openExit}
          constants={this.props.constants}
          refresh = {this.refresh}
          viewImage = {this.viewImage}
          employees={this.state.employees}/>}
      </div>
    );
  }

}

ExitHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state
  };
}

export default connect(mapStateToProps)(ExitHome);




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/Exit/ExitHome.js
 **/